import type { App } from 'vue'

import { abilitiesPlugin } from '@casl/vue'
import type { Rule } from './ability'
import { ability } from './ability'

// DAY-37: install the shared `ability` instance, so code outside components (router guards)
// updates the same rules the menus and pages read.
export default function (app: App) {
  const userAbilityRules = useCookie<Rule[]>('userAbilityRules')

  ability.update(userAbilityRules.value ?? [])

  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
}
